<template>

    <form action="/search" method="get">
        <div class="input-group">
            <input type="text" class="form-control input_w_btn" name="s" autocomplete="off"
                placeholder="Поиск товаров по назв. или арт." v-model="text"
                @input="onChange"
                @focus="onInputFocus"
                @blur="onInputBlur"
                >

            <ul class="dropdown-menu search_onthefly"
                :class="{ show: this.show }"
                role="menu"
                aria-labelledby="search_onthefly_menu"
                @mouseover="onDropdownFocus"
                @mouseleave="onDropdownBlur"
                >

                <template v-if="showHistory">
                    <li v-for="(item, index) in history" v-bind:key="index" class="list-group-item d-flex justify-content-left">
                        <i class="f7-icons icon_sm search_onthefly_icon">arrow-counterclockwise</i>
                        <a :href="'/search?s=' + item.text"><span><b>{{ item.text }}</b></span></a>
                    </li>
                </template>

                <template v-if="showPopular">
                    <li v-for="(item, index) in popular" v-bind:key="index + 1000" class="list-group-item d-flex justify-content-left">
                        <i class="f7-icons icon_sm search_onthefly_icon">search</i>
                        <a :href="'/search?s=' + item.text"><span><b>{{ item.text }}</b></span></a>
                    </li>
                </template>

                <template v-if="showAllPopular">
                    <li v-for="(item, index) in allPopular" v-bind:key="index + 2000" class="list-group-item d-flex justify-content-left">
                        <i class="f7-icons icon_sm search_onthefly_icon">search</i>
                        <a :href="'/search?s=' + item.text"><span><b>{{ item.text }}</b></span></a>
                    </li>
                </template>

                <template v-if="showCategories">
                    <li v-for="(item, index) in categories" v-bind:key="index + 3000" class="list-group-item d-flex justify-content-left">
                        <i class="f7-icons icon_sm search_onthefly_icon">folder</i>
                        <a :href="'/catalog/category/' + item.slug"><span>
                            <template v-if="item.parent_category">
                                {{ item.parent_category.title }} /
                            </template>{{ item.title }}</span></a>
                    </li>
                </template>

                <template v-if="showItems">
                    <li v-for="(item, index) in items" v-bind:key="index + 4000" class="list-group-item d-flex justify-content-left">
                        <div class="item_picture">
                            <a :href="'/catalog/item/' + item.slug">
                                <div v-if="item.images && item.images[0] && item.images[0].thumb_path" :style="'background-image: url(' + item.images[0].thumb_path + ')'"></div>
                                <div v-else-if="item.images && item.images[0] && item.images[0].thumb_path" :style="'background-image: url(' + item.images[0].thumb_path + ')'"></div>
                            </a>
                        </div>
                        <a :href="'/catalog/item/' + item.slug"><span>{{ item.title }} <div class="price_sm">{{ item.price }} р.</div></span></a>
                    </li>

                    <li v-if="showItems" class="list-group-item d-flex justify-content-left">
                        <div class="item_picture"><a :href="'search?s=' + this.text"><div></div></a></div>
                        <a :href="'/search?s=' + this.text">Результаты поиска товаров <div><b>{{ total }} шт.</b></div></a>
                    </li>
                </template>
            </ul>

            <div class="input-group-append">
                <button class="btn btn_lg btn_form" type="submit"><i
                        class="f7-icons icon_lg d-sm-none">search</i><span
                        class="d-none d-sm-inline">Найти</span></button>
            </div>

        </div>
    </form>

</template>

<script>
import { Fragment } from "vue-fragment";

export default {
    props: ["search"],

    components: { Fragment },

    data: function () {
        return {
            text: this.search,
            items: [],
            categories: [],
            history: [],
            popular: [],
            allPopular: [],
            total: 0,
            hiddenInput: true,
            hiddenDropdown: true
        };
    },

    computed: {
        hidden() {
            return this.hiddenInput && this.hiddenDropdown;
        },

        show() {
            return !this.hidden && (
                this.items.length
                || this.categories.length
                || this.history.length
                || this.popular.length
                || this.allPopular.length
            );
        },

        showItems() {
            return this.text.length >= 3 && this.items.length;
        },

        showCategories() {
            return this.text.length >= 3 && this.categories.length ;
        },

        showHistory() {
            return this.text.length < 3 && this.history.length ;
        },

        showPopular() {
            return this.text.length >= 3 && this.popular.length;
        },

        showAllPopular() {
            return this.text.length < 3 && this.allPopular.length;
        },
    },

    methods: {
        onInputFocus: function() {
            if (this.text.length >= 3 && !this.items.length && !this.categories.length) {
                this.getSearch();
            }

            this.hiddenInput = false;
        },

        onDropdownFocus: function() {
            this.hiddenDropdown = false;
        },

        onInputBlur: function() {
            this.hiddenInput = true;
        },

        onDropdownBlur: function() {
            this.hiddenDropdown = true;
        },

        onChange: function() {
            this.getSearch();
        },

        getSearch: function() {
            this.items = [];
            this.categories = [];
            this.total = 0;

            if (this.text.length < 3) return;

            let params = {
                s: this.text
            };

            axios.get('/ajax/search/fly', { params: params })
                .then(request => {
                    this.items = request.data.items;
                    this.popular = request.data.popular;
                    this.categories = request.data.categories;
                    this.total = request.data.total;
                });
        },
    },

    mounted: function() {
        axios.get('/ajax/search/history')
            .then(request => {
                console.log(request.data);
                this.history = request.data.history;
                this.allPopular = request.data.popular;
            });
    }
};
</script>
